module.exports = __webpack_public_path__ + "img/logon-noel.e3465f64.svg";